
import EmptyWalletTime from "../../../assets/filled/EmptyWalletTime.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EmptyWalletTimeIcon({ className, dataTestid = "EmptyWalletTimeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <EmptyWalletTime data-testid={dataTestid} className={classes} {...rest} />
  );
}
